import { Link } from "react-router-dom";
import { discountLabel } from "../../lib/brand";
import { MapPin } from "@phosphor-icons/react";

export default function MerchantCard({ merchant }) {
  const cover = merchant.cover_url || merchant.gallery?.[0];
  return (
    <Link to={`/partners/${merchant.id}`} className="tsc-card group overflow-hidden block" data-testid={`merchant-card-${merchant.id}`}>
      <div className="aspect-[4/3] bg-[#0a0a0a] overflow-hidden relative">
        {cover ? (
          <img src={cover} alt={merchant.business_name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20 font-display text-3xl">TSC</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          {merchant.featured && (
            <span className="bg-gold-gradient text-black text-[9px] font-semibold tracking-luxe px-2.5 py-1 rounded-full">FEATURED</span>
          )}
          {merchant.category?.name && (
            <span className="bg-black/70 border border-[#D4AF37]/30 text-[#D4AF37] text-[9px] tracking-luxe px-2.5 py-1 rounded-full uppercase">{merchant.category.name}</span>
          )}
        </div>
        <div className="absolute bottom-3 right-3 bg-black/85 border border-[#D4AF37]/40 px-3 py-1.5 rounded-full">
          <span className="text-[#D4AF37] text-[10px] tracking-luxe uppercase font-medium">
            Member: {discountLabel(merchant.member_discount_type, merchant.member_discount_value)}
          </span>
        </div>
      </div>
      <div className="p-4">
        <p className="font-display text-xl text-white leading-tight group-hover:text-[#F9E596] transition-colors">{merchant.business_name}</p>
        {merchant.primary_branch && (
          <div className="flex items-center gap-1.5 mt-1 text-white/60 text-xs">
            <MapPin size={12} className="text-[#D4AF37]" />
            <span>{merchant.primary_branch.branch_name}{merchant.primary_branch.city ? ` · ${merchant.primary_branch.city}` : ""}</span>
          </div>
        )}
        <p className="text-white/50 text-xs mt-2 line-clamp-2 min-h-[2.4em]">{merchant.description}</p>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-[10px] tracking-luxe uppercase text-white/40">Active members only</span>
          <span className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">View →</span>
        </div>
      </div>
    </Link>
  );
}
